import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  AssetService,
  AssetType,
} from '@rd/core/services/asset-service/asset.service';
import { UrlUtilsService } from '../url-utils/url-utils.service';

@Injectable({
  providedIn: 'root',
})
export class IconRegistryService {
  cacheMap = new Map<string, boolean>();

  constructor(
    private iconRegistry: MatIconRegistry,
    private urlUtilsService: UrlUtilsService,
    private sanitizer: DomSanitizer,
    private assetService: AssetService,
  ) {}

  // Standard icons are to follow the following:
  // 1) Have icon- as a prefix before the icon name
  // 2) Be located in /assets/icons directory
  //
  // In cases where we want to not put the icon in the default path (ex: non-standard icon or SVG),
  // then call this method with the suppliedPath argument
  registerIcon(iconSymbol: string, suppliedPath?: string): void {
    let path;

    if (suppliedPath) {
      path = suppliedPath;
    } else {
      const pathFromService = this.assetService.getAssetPath(
        iconSymbol,
        AssetType.Icon,
      );
      if (pathFromService) {
        path = pathFromService;
      } else {
        path = `/icons/icon-${iconSymbol}.svg`;
      }
    }

    if (this.cacheMap.get(iconSymbol)) {
      return;
    }
    this.cacheMap.set(iconSymbol, true);
    this.iconRegistry.addSvgIcon(
      `icon-${iconSymbol}`,
      this.sanitizer.bypassSecurityTrustResourceUrl(
        this.urlUtilsService.imageUrl(path),
      ),
    );
  }
}
